import { render, staticRenderFns } from "./EditorToolbar.vue?vue&type=template&id=18485fad"
import script from "./EditorToolbar.vue?vue&type=script&lang=js"
export * from "./EditorToolbar.vue?vue&type=script&lang=js"
import style0 from "./EditorToolbar.vue?vue&type=style&index=0&id=18485fad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports